module.exports = __webpack_public_path__ + "media/images/official/special_migration_13-e9dec77e79a4f374d09ff83f6754f666.jpg";